import { appPaths } from 'consts/paths/paths';
import { ChildEdit } from 'components/templates';

export const ChildEditPage = () => <ChildEdit childrenPagePath={appPaths.app.children.base} />;
